import type {ClassValue} from 'clsx';
import clsx from 'clsx';
import {extendTailwindMerge} from 'tailwind-merge';

// Register custom theme values from public/globals.css so tailwind-merge
// resolves conflicts for them (e.g. `shadow-card` would otherwise be
// treated as a shadow color).
const twMerge = extendTailwindMerge({
	extend: {
		theme: {
			shadow: ['card'],
			animate: [
				'expand',
				'scaleIn',
				'scaleOut',
				'fadeIn',
				'fadeOut',
				'enterFromLeft',
				'enterFromRight',
				'exitToLeft',
				'exitToRight',
				'slideDown',
				'slideUp',
			],
		},
	},
});

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
